import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import ErrorMessageBlock from "../ErrorMessageBlock";
import EditTariffForm from "./EditTariffForm";

const EditTariffModal = ({ open, setOpen, handleSubmit, showError }) => {
  return (
    <Dialog className="relative z-10" open={open} onClose={() => {}}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-dark-gray bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full justify-center p-4 text-center items-start sm:p-0">
          <DialogPanel
            transition
            className="relative sm:my-8 sm:w-full sm:max-w-[645px] transform overflow-hidden transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="rounded-[24px] bg-white text-left shadow-xl overflow-hidden p-8">
              {showError && (
                <ErrorMessageBlock
                  errorTitle="Failed to fetch your existing tariff."
                  errorSubtitle="Please enter your current tariff details."
                />
              )}
              <EditTariffForm
                setShowEditTariffForm={setOpen}
                handleSubmit={handleSubmit}
              />
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default EditTariffModal;
